import { render, staticRenderFns } from "./PurchaseOrderCheckout.vue?vue&type=template&id=56d8e0b0&scoped=true&"
import script from "./PurchaseOrderCheckout.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d8e0b0",
  null
  
)

export default component.exports